import fetchApi from "../fetchApi";
export const getCardByPrn = async (
    {prn}
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/cardholder/${prn}`, options);
};